var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3404 9.56049C17.8603 7.25894 21.1397 7.25894 21.6596 9.56049C21.9965 11.0521 23.7082 11.7612 25.0012 10.9447C26.9963 9.68483 29.3152 12.0037 28.0553 13.9988C27.2388 15.2918 27.9479 17.0035 29.4395 17.3404C31.7411 17.8603 31.7411 21.1397 29.4395 21.6596C27.9479 21.9965 27.2388 23.7082 28.0553 25.0012C29.3152 26.9963 26.9963 29.3152 25.0012 28.0553C23.7082 27.2388 21.9965 27.9479 21.6596 29.4395C21.1397 31.7411 17.8603 31.7411 17.3404 29.4395C17.0035 27.9479 15.2918 27.2388 13.9988 28.0553C12.0037 29.3152 9.68483 26.9963 10.9447 25.0012C11.7612 23.7082 11.0521 21.9965 9.56049 21.6596C7.25894 21.1397 7.25894 17.8603 9.56049 17.3404C11.0521 17.0035 11.7612 15.2918 10.9447 13.9988C9.68483 12.0037 12.0037 9.68483 13.9988 10.9447C15.2918 11.7612 17.0035 11.0521 17.3404 9.56049Z",
    fill: "#917AFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5L18.5217 22L24 17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.de0d935a6196c29bb96d025ef023a1b7.svg";
export { ForwardRef as ReactComponent };